import React from 'react';
import { useHistory } from "react-router-dom";

const CarListError = (props) => {
    const history = useHistory();


    return (
        <div class="container-fluid inner-page-space">
            <div class="wrapper">
                <div class="error-position-carlist">
                    <div class="">
                        <div class="error-oops">
                            <i class="icofont-warning"></i>
                            <p>Something Went Wrong</p>
                        </div>
                        <div class="page-fourerror">
                            <p>{props.error}</p>
                        </div>
                        <div class="page-message">
                            {props.error === "Unauthorized User" ?
                                <p>Unauthorized User Exception-You do not have the Authorization to access this page.For more queries Contact URSecondLot Admin info@ur2ndlot.com.</p> :
                                <p>There was a problem processing the request. For more queries Contact URSecondLot Admin info@ur2ndlot.com.</p>}
                        </div >
                        <div >
                            <button onClick={() => history.goBack()} class="page-error-button">Return to last page</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default CarListError